<div class="caremoni-number-box input-style" [ngStyle]="inputParams.inputStyle">
  <div class="caremoni-number-box-content" *ngIf="!inputParams.hidden">
    
    <div class="input-wrapper">

      <input
        class="caremoni-input"
        min="0"
        [type]="inputType === 'number' ? 'text' : inputType"
        [attr.inputmode]="inputType === 'number' ? 'numeric' : null"
        [value]="inputValue"
        [attr.dpad]="dpad"
        [style.--scale-dpad]="scaledpad"
        [attr.x-dpad]="xdpad"
        [attr.y-dpad]="ydpad"
        [attr.tab-dpad]="tabdpad"
        [attr.x-tab-dpad]="xtabdpad"
        [attr.y-tab-dpad]="ytabdpad"
        [tabIndex]="inputParams.tabindex || 1"
        [disabled]="inputParams.disabled"
        [readonly]="inputParams.readonly"
        [ngClass]="{
          'input-text-center': textCenter,
          'caremoni-input-err': inputParams.validate && (showValidateErr || inputParams.isValidate)
        }"
        (keydown)="onKeyDowns($event)"
        (click)="onClicks($event)"
        (focus)="onFocusIn($event)"
        (focusout)="onFocusOutInput($event)"
        (input)="onInputData($event)"
        (keyup)="onKeyUps($event)"
      />

      <!-- clear button -->
      <span *ngIf="canClear && !empty(inputValue)" class="item-delete" (click)="clearText()">
        <i class="pi pi-times"></i>
      </span>

      <!-- number controls -->
      <div class="number-box-controls" *ngIf="inputType === 'number'">
        <button
          class="increment-btn"
          type="button"
          (click)="incrementValue()"
          [disabled]="inputParams.disabled"
        >
          &#9650;
        </button>

        <button
          class="decrement-btn"
          type="button"
          (click)="decrementValue()"
          [disabled]="inputParams.disabled"
        >
          &#9660;
        </button>
      </div>

    </div>
  </div>

  <label
    *ngIf="inputParams.validate && (showValidateErr || inputParams.isValidate)"
    class="caremoni-validate-err"
  >
    {{ inputParams.validateError }}
  </label>
</div>